const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAffideaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "affidea-logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 216.9 54.6",
    style: {
      enableBackground: "new 0 0 216.9 54.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4181D0"
    },
    cx: 27.3,
    cy: 27.3,
    r: 27.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "affidea-logo-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: -819.8046,
    y1: 558.116,
    x2: -818.8046,
    y2: 558.116,
    gradientTransform: "matrix(27.2805 0 0 -54.561 22391.9863 30478.6484)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    style: {
      stopColor: "#4181D0",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    style: {
      stopColor: "#3B6FB0",
      stopOpacity: 0.145
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    style: {
      stopColor: "#314D72",
      stopOpacity: 0.439
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    style: {
      stopColor: "#293446",
      stopOpacity: 0.694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491,
    style: {
      stopColor: "#25252A",
      stopOpacity: 0.886
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.55,
      fill: "url(#affidea-logo-gradient)",
      enableBackground: "new"
    },
    d: "M27.3,0c15.1,0,27.3,12.2,27.3,27.3      S42.3,54.6,27.3,54.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4181D0"
    },
    d: "M65.3,53.9H43.5L27.3,0h21.8L65.3,53.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4181D0"
    },
    d: "M87.5,35.9c-1.9,1.6-4.3,2.5-6.7,2.5c-1.9,0-3.8-0.5-5.5-1.4      c-5.5-3.3-7.2-10.5-3.9-15.9c1-1.6,2.3-2.9,3.9-3.9c1.6-0.9,3.4-1.4,5.3-1.3c2.5,0,4.9,0.8,6.8,2.5v-2h4.2v21.7h-4.2v-2.1H87.5z       M87.4,22.9c-1.5-1.9-3.8-3.1-6.2-3.1c-3.8,0-6.9,3.1-6.9,6.9c0,0.1,0,0.2,0,0.3c-0.1,3.9,3.1,7.1,6.9,7.1c0.1,0,0.2,0,0.3,0      c2.4-0.1,4.6-1.2,6-3.1v-8.1H87.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4181D0"
    },
    d: "M128.2,9c-0.5-0.1-1.1-0.2-1.7-0.2c-1.3,0-2.5,0.5-3.3,1.5c-0.6,0.8-0.8,1.9-0.8,3.9v2      h16.1v21.7h-4.3V20h-11.8v17.8h-4.3V20h-11.8v17.8H102V20h-5.1v-3.9h5.1v-1.9c0-2.9,0.4-4.8,1.3-6.1c1.6-2.3,4.3-3.7,7.1-3.6      c0.9,0,1.7,0.1,2.6,0.3l-0.9,4c-0.5-0.1-1.1-0.2-1.7-0.2c-1.3,0-2.5,0.5-3.3,1.5c-0.6,0.8-0.8,1.9-0.8,3.9v2h11.8v-1.9      c0-2.9,0.4-4.8,1.3-6.1c1.6-2.3,4.3-3.7,7.1-3.6c0.9,0,1.7,0.1,2.6,0.3L128.2,9z M136.4,5.1c1.6,0,2.9,1.3,2.9,2.9      s-1.3,2.9-2.9,2.9c-1.6,0-2.9-1.2-2.9-2.8c0,0,0-0.1,0-0.1C133.6,6.4,134.8,5.1,136.4,5.1L136.4,5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4181D0"
    },
    d: "M161,35.9c-1.9,1.6-4.3,2.5-6.7,2.5c-1.9,0-3.8-0.5-5.5-1.4c-3.5-2-5.6-5.8-5.5-9.8      c0-4.1,2.1-7.8,5.6-9.9c1.6-0.9,3.4-1.4,5.3-1.3c2.4,0,4.8,0.8,6.6,2.4V5.5h4.3v32.3h-4.2v-2H161z M160.9,22.9      c-1.5-1.9-3.8-3.1-6.2-3.1c-3.8,0-6.9,3.1-6.9,6.9c0,0.1,0,0.2,0,0.3c0,3.9,3.1,7.1,7.1,7.1c0.1,0,0.1,0,0.2,0      c2.3-0.1,4.5-1.2,5.9-3.1V22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4181D0"
    },
    d: "M174.4,28c0.2,3.7,3.3,6.6,7,6.5c2.4,0,4.7-1.1,6.2-3l2.9,2.7c-2.2,2.7-5.6,4.2-9.1,4      c-6,0.1-11-4.7-11.2-10.7c0-0.2,0-0.4,0-0.5c0-6.5,4.4-11.3,10.5-11.3c6,0,10.4,4.9,10.4,11.3v0.9h-16.8V28z M174.8,24.3h11.8      c-0.6-2.7-2.9-4.6-5.7-4.6C178.1,19.6,175.6,21.5,174.8,24.3L174.8,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4181D0"
    },
    d: "M212.8,35.9c-1.9,1.6-4.3,2.5-6.7,2.5c-1.9,0-3.8-0.5-5.5-1.4c-3.5-2-5.6-5.8-5.6-9.8      c0-4.1,2.1-7.8,5.6-9.9c1.6-0.9,3.4-1.4,5.3-1.3c2.5,0,4.9,0.8,6.8,2.5v-2h4.2v21.6h-4.2v-2.1H212.8z M212.7,23      c-1.5-1.9-3.8-3.1-6.2-3.1c-3.8,0-6.9,3.1-6.9,6.9c0,0.1,0,0.2,0,0.3c0,3.9,3.1,7.1,7.1,7.1c0.1,0,0.1,0,0.2,0      c2.4-0.1,4.6-1.2,6-3.1V23H212.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffideaLogo);
export default __webpack_public_path__ + "static/media/affidea-logo.396057be688f0115ef4a7ea1bf217cb7.svg";
export { ForwardRef as ReactComponent };